












import Vue from 'vue'
import PasswordSetting from '@/components/SettingPassword.vue'
import {
  ConferenceProfile,
  Configuration,
  PasswordResetInfoUserTypeEnum,
  PublicRestControllerApi,
} from '@/types/api-docs'
import NotFound from '@/components/NotFound.vue'
import Utils from '@/utils/utils'

export interface DataType {
  profile?: ConferenceProfile
  userType: PasswordResetInfoUserTypeEnum
  notFound: boolean
}

const api = new PublicRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export default Vue.extend({
  components: {
    NotFound,
    PasswordSetting,
  },
  data(): DataType {
    return {
      profile: undefined,
      userType: PasswordResetInfoUserTypeEnum.Member,
      notFound: false,
    }
  },
  async mounted() {
    await this.fetchConferenceProfile()
  },
  methods: {
    async fetchConferenceProfile() {
      const options = {
        query: Utils.getQueryParams(),
      }

      await api
        .fetchConferenceProfile(options)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((res: any) => {
          this.profile = res.data
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((err: any) => {
          const res = err.response
          const status = res === undefined ? undefined : res.status
          if (status === 404) {
            this.notFound = true
          }
        })
    },
  },
})
